import { AnnouncementsPage } from '@repo/ui/features/platform';

export default function SuperAdminAnnouncementsPage() {
  return (
    <div className="w-full py-6">
      <AnnouncementsPage />
    </div>
  );
}
